{
  "nav": {
    "inicio": "Inicio",
    "contacto": "Contacto",
    "pago": "Pago"
  },
  "common": {
    "loading": "Cargando...",
    "error": "Ha ocurrido un error",
    "back": "Volver",
    "close": "Cerrar",
    "more_info": "Más información"
  }
}
